import React from 'react';
import { Drawer } from '../../../../components';
import { useStyles } from '../../../../services/material-ui';
import FormUserAdmin from '../../../../components/FormUser/FormUserAdmin';

const EditUser: React.FC = () => {
  const classes = useStyles();

  return (
    <div className="container-dash">
      <Drawer />
      <main className={classes.content}>
        <FormUserAdmin />
      </main>
    </div>
  );
};

export default EditUser;
